<div class="title">
    Are you sure?
</div>

<p class="description">
  Choose “Yes” to Delete Folder
</p>

<div class="modal-actions">
  <button mat-button (click)="matDialogRef.close(false)">No</button>
  <button mat-button color="primary" (click)="matDialogRef.close(true)">Yes</button>
</div>
